import { h } from "preact";
import { useState } from "preact/hooks";
import BlogCardBadge from "./blog-card-badge";
import BlogCardVideo from "./blog-card-video";

export default function BlogCardWide({ article }) {
  const {
    readTime,
    videoPost,
    tags,
    title,
    excerpt,
    image,
    horizontalImage,
    onlineStoreUrl,
    videoMobile,
    video,
  } = article;

  const [play, setPlay] = useState(false);
  const isVideoPost = videoPost?.value === "true";
  const relativeUrl = new URL(onlineStoreUrl).pathname;
  const mediaImage = horizontalImage?.reference.image || image;
  const mediaImagePresentation = horizontalImage?.reference?.presentation ?? null;
  const mediaVideo = videoMobile?.reference || video?.reference;

  const media = () => {
    if (isVideoPost && mediaVideo) {
      return (
        <BlogCardVideo
          className="blog-card-wide__video"
          video={mediaVideo}
          play={play}
        />
      );
    }

    if (mediaImage) {
      const focalPoints = mediaImagePresentation
        ? `${mediaImagePresentation.asJson.focalPoint.x * 100}% ${mediaImagePresentation.asJson.focalPoint.y * 100}%`
        : null;

      return (
        <img
          className="blog-card__image"
          src={getSizedImageUrl(mediaImage.url, "x800")}
          alt={mediaImage.altText}
          {...(focalPoints ? { style: { objectPosition: focalPoints } } : {})}
        />
      );
    }

    return null;
  };

  return (
    <a
      href={relativeUrl}
      className="blog-card-wide"
      onMouseOver={() => setPlay(true)}
      onMouseLeave={() => setPlay(false)}
    >
      <BlogCardBadge readTime={readTime} videoPost={isVideoPost} />
      <div className="blog-card-wide__content">
        {tags.length > 0 && (
          <div className="blog-card-wide__tag">{tags[0]}</div>
        )}
        <h3 className="blog-card-wide__title">{title}</h3>
        <div className="blog-card-wide__excerpt">{excerpt}</div>
      </div>
      {media()}
    </a>
  );
}
